import { RepoType } from '@quyva/common';
import { RepoStatKey } from './repoStatKeys';

const {
    NO_OF_FILES, TOTAL_SIZE, TOTAL_PAGES, TOTAL_TABLES, SCHEMA_SIZE_KB,
    MANUAL_ANNOTATION, CREATED_AT, UPDATED_AT, PROCESSING_TIME, USED_CREDITS,
    LLM_MODEL, EMBEDDING_MODEL,
} = RepoStatKey;

export const repoStatsConfig = {
    [RepoType.INTERNET]: {
        admin: [
            [TOTAL_PAGES, LLM_MODEL, EMBEDDING_MODEL],
            [CREATED_AT, UPDATED_AT],
            [PROCESSING_TIME, USED_CREDITS],
        ],
        user: [
            [TOTAL_PAGES, LLM_MODEL],
            [CREATED_AT, UPDATED_AT],
            [EMBEDDING_MODEL],
        ],
    },
    DEFAULT: {
        admin: [
            [NO_OF_FILES, TOTAL_SIZE, TOTAL_PAGES],
            [CREATED_AT, UPDATED_AT, PROCESSING_TIME],
            [LLM_MODEL, EMBEDDING_MODEL, USED_CREDITS],
        ],
        user: [
            [NO_OF_FILES, TOTAL_SIZE, TOTAL_PAGES],
            [CREATED_AT, UPDATED_AT],
            [LLM_MODEL, EMBEDDING_MODEL],
        ],
    },
};


export const repoStatsDbConfig = {
    admin: [
        [TOTAL_TABLES, SCHEMA_SIZE_KB, MANUAL_ANNOTATION],
        [CREATED_AT, UPDATED_AT, PROCESSING_TIME],
        [EMBEDDING_MODEL, USED_CREDITS],
    ],
    user: [
        [TOTAL_TABLES, SCHEMA_SIZE_KB],
        [CREATED_AT, UPDATED_AT],
        [EMBEDDING_MODEL, MANUAL_ANNOTATION],
    ],
};
